import { SVGAttributes } from 'react';

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 225.5 225.5"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M191.24,0H34.27C15.34,0,0,15.34,0,34.27v156.97c0,18.93,15.34,34.27,34.27,34.27h156.97c18.93,0,34.27-15.34,34.27-34.27V34.27c0-18.93-15.34-34.27-34.27-34.27ZM59.71,88.47c1.34-1.43,19.08-3.4,30.88,0,8.36,2.41,11.35,8.35,12.99,18.5h-46.01c-2.43-5.27-.15-16.05,2.14-18.5ZM187.96,163.22c0,7.34-14.37,7.34-14.37,0v-20.4c0-.38-.31-.7-.69-.7l-36.17-.57c-.62,0-.92-.76-.49-1.2l25.53-25.53c.13-.13.31-.21.5-.21h17.71s.05,0,.07,0c4.27.34,7.69,1.88,7.92,7.95v40.66ZM194.84,71.35l-82.24,82.32c-.1.1-.22.18-.35.24-2,.75-3.28.21-4.54-.31-1.3-.54-9.94-11.01-13.91-11.77-3.6-.69-35.42-.13-41.38-.02-.54.01-.96.45-.96.98v19.93s0,.07,0,.11c-.07.63-.89,6.18-8.25,5.6-6.73,0-6.42-7.64-6.42-7.64v-88.31s0-.06,0-.09c.06-.66.9-7.75,7.03-7.75,8.56,0,7.64,7.03,7.64,7.03v40.75c0,.54.44.98.98.98h51.12c.12,0,.23.01.34.05,7.23,2.59,8.7,11.87,11.83,14.49.39.33.97.32,1.34-.04l70.21-68.69s3.95-2.63,8.48,1.91c4.74,4.74-.92,10.24-.92,10.24Z"
            />
        </svg>
    );
}
